const [d] = [document];
const domReady = TPL => {
  let Mv = document.querySelector('.mainvisual');
  window.addEventListener('load', function() {
    Mv? Mv.classList.add('loaded'): false;
  });
  getArticleToModal( $('#exampleModal .modal-body'), {content: 'service',post_id: 7});
};

const getArticleToModal = ( $modalBody, param ) => {
  
  const applyDom = article => $modalBody.html( article.body );

  fetch(`/assets/api/getArticles/?${ new URLSearchParams(param)}`)
    .then( res => res.json()).then( res => applyDom(...res) );
}

const moreInfo = () => {
  $('.more_btn').on('click', function(){
    $(this).toggleClass('open');
    $(this).parents('.btn_wrap').prev('.slide_wrap').toggleClass('open')
  });
}

const menuClose = () => {
  $('.rwd002-gnav__list a').on('click', function(){
    $('.rwd002-gnav').removeClass('is-active');
    $('.rwd002-header__drawerBtn').removeClass('is-active');
  });
}

const jqInit = () => false;

const onload = () => {
  let mk2 = $('.mark2').offset().top;
  let mk3 = $('.mark3').offset().top;

  $(window).on('scroll', function(){
    let wrapPt = $('.scroll_wrap').offset().top;
    
    if(mk2 < wrapPt && wrapPt < mk3 ){
      $('.point_wrap').removeClass('here')
      $('.point2').addClass('here');
      $('.pager a').removeClass('current');
      $('.pager .p2').addClass('current');
    } else if(mk3 <= wrapPt){
      $('.point_wrap').removeClass('here')
      $('.point3').addClass('here');
      $('.pager a').removeClass('current');
      $('.pager .p3').addClass('current');
    } else {
      $('.point_wrap').removeClass('here')
      $('.point1').addClass('here');
      $('.pager a').removeClass('current');
      $('.pager .p1').addClass('current');
    }
    
    let scrollWpH = $('.scroll_wrap').height() / 2;
    let scrollSt = $('.block-strength').offset().top + scrollWpH;
    let scrollEd = $('.block-strength').offset().top + $('.block-strength').height() - scrollWpH;
    let H = $(window).height();
    let scroll = $(this).scrollTop();
    let scrollCt = scroll + H / 2;
    if(scrollCt > scrollSt && scrollEd > scrollCt){
      $('.scroll_wrap').removeClass('stop');
      $('.scroll_wrap').addClass('fixed');
    } else if (scrollCt > scrollEd){
      $('.scroll_wrap').removeClass('fixed');
      $('.scroll_wrap').addClass('stop');
    } else {
      $('.scroll_wrap').removeClass('stop');
      $('.scroll_wrap').removeClass('fixed');
    }
  });
}

export default function LP () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  
  $(() => jqInit());

  $(window).on('load', onload );
  $(window).on('load', moreInfo );
  let w = $(window).width();
  if(w < 900){
    $(window).on('load', menuClose );
  }
}
